import { I18nAndL10n } from '@application/i18n/i18n_and_l10n';
import { withTranslation } from '@application/i18n/with_translation';
import { ButtonArrange, type CellulaFormSubmitData, Flex, Form, Spacer, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Title } from '@component/title.component';
import { TopBar } from '@component/top_bar.component';
import { type ReactNode } from 'react';
import { useInformationGatheringJourney } from './use-information-gathering-journey';

interface InformationGatheringFormProps<TData extends CellulaFormSubmitData> {
	title: I18nAndL10n.LocaleKey;
	description?: I18nAndL10n.LocaleKey;
	defaultValues: TData;
	onSubmit(data: TData): void | Promise<void>;
	goBack(event: Event): void;
	children: ReactNode;
}

export function InformationGatheringForm<TData extends CellulaFormSubmitData>({
	title,
	description,
	defaultValues,
	onSubmit,
	goBack,
	children,
}: InformationGatheringFormProps<TData>) {
	const { isSaving, saveError } = useInformationGatheringJourney();

	return (
		<>
			<TopBar.Content goBack goBackIntercept={goBack} />
			<Form.Root options={{ defaultValues, mode: 'onBlur' }} onSubmit={(data) => onSubmit(data as TData)}>
				<Flex grow={1} gap={tokens.spacing.x2}>
					<Title
						title={withTranslation(title)}
						titleSize='small'
						description={description === undefined ? undefined : withTranslation(description)}
					/>
					{children}
					{saveError ? <Text variant='bodyRegular'>{withTranslation('Error.Patient.Unknown')}</Text> : null}
				</Flex>
				<Spacer vertical={tokens.spacing.x2} />
				<ButtonArrange>
					<Form.SubmitButton disabled={isSaving} disabledText={isSaving ? withTranslation('PW.Common.Next') : ''}>
						{withTranslation('PW.Common.Next')}
					</Form.SubmitButton>
				</ButtonArrange>
			</Form.Root>
		</>
	);
}
